import DamageHallSelectField from "./damage-hall-select-field";
import DamageBlockSelectField from "./damage-block-select-field";
import DamageStandNumberSelectField from "./damage-stand-number-select-field";
import DamageStatusSelectField from "./damage-status-select-field";

const DamageFields = {
    StatusSelect: DamageStatusSelectField,
    HallSelect: DamageHallSelectField,
    BlockSelect: DamageBlockSelectField,
    StandNumberSelect: DamageStandNumberSelectField
};

export default DamageFields;
